import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';
import React from 'react';

interface DropDownProps {
  isOpen: boolean; // Determines if the dropdown is open
  onToggle: () => void; // Function to toggle the dropdown state
  fontSize?: string; // Font size of the label
  fontWeight?: string; // Font weight of the label
  showLabel?: string; // Label when the dropdown is closed
  hideLabel?: string; // Label when the dropdown is open
  color?: string; // Color of the label
}

const AccordionButton: React.FC<DropDownProps> = ({
  isOpen,
  onToggle,
  fontSize = 'text-[23px]',
  fontWeight = 'font-bold',
  showLabel = 'Show summary',
  hideLabel = 'Hide summary',
  color = '#FFFFFF',
}) => {
  return (
    <button onClick={onToggle} className="w-full py-2">
      {isOpen ? (
        <div className="flex items-center">
          <span
            style={{ color: color }}
            className={`${fontSize} ${fontWeight}`}>
            {hideLabel}
          </span>
          <ChevronUpIcon
            style={{ color: color }}
            className={`h-5 w-5 ml-2 `}
            aria-hidden="true"
          />
        </div>
      ) : (
        <div className="flex items-center">
          <span
            style={{ color: color }}
            className={`${fontSize} ${fontWeight}`}>
            {showLabel}
          </span>
          <ChevronDownIcon
            style={{ color: color }}
            className={`h-5 w-5 ml-2 `}
            aria-hidden="true"
          />
        </div>
      )}
    </button>
  );
};

export default AccordionButton;
